( function ( $ ) {
	"use strict";

	if ( 'undefined' === typeof GARBE_GOOGLE_MAPS_API_KEY ) {
		throw new Error(
			'Please define the constant GARBE_GOOGLE_MAPS_API_KEY before embedding the file maps.js'
		);
	}

	function isMobile() {
		return 500 >= Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	}

	function showInfoWindowReplacement( mapElement, content ) {
		var $map = $( mapElement ),
			$infoWindow = $( '<div class="info-window-container"></div>' ).html( content );

		if ( $map.next().is( '.info-window-container' ) ) {
			$map.next().remove();
		}

		$map.after( $infoWindow );
	}

	function createMap( element, options ) {
		var icon = null,
			activeIcon = null,
		    currentlyOpenInfoWindow = null;

		var map = new GMaps( {
			div: element,
			lat: options.center.lat,
			lng: options.center.lng,
			draggable: true,
			scrollwheel: false,
			mapTypeControl: false,
			zoomControl: 'boolean' === typeof options.zoomControl ? options.zoomControl : true,
			scaleControl: true,
			streetViewControl: true,
			zoom: options.zoom,
			styles: [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			]
		} );

		if ( 0 < options.zoomSwitchToSatelliteView ) {
			map.addListener( 'zoom_changed', function () {
				if ( map.getZoom() >= options.zoomSwitchToSatelliteView ) {
					map.setMapTypeId( google.maps.MapTypeId.SATELLITE );
				} else {
					map.setMapTypeId( google.maps.MapTypeId.ROADMAP );
				}
			} );
		}

		if (options.markers) {
			if (options.markerIcon) {
				icon = {
					url: options.markerIcon,
					scaledSize: new google.maps.Size(20, 20)
				};
			}

			if (options.activeMarkerIcon) {
				activeIcon = {
					url: options.activeMarkerIcon,
					scaledSize: new google.maps.Size(20, 20)
				};
			}

			options.markers.forEach(function (data) {
				var infoWindow = new google.maps.InfoWindow( {
					content: data.content,
					maxWidth: 400
				} );

				var marker = map.addMarker( {
					lat: data.coordinates.lat,
					lng: data.coordinates.lng,
					icon: icon,
					infoWindow: infoWindow
				} );

				google.maps.event.addListener( marker, 'click', function () {
					if ( activeIcon ) {
						marker.setIcon( activeIcon );
					}

					if (isMobile()) {
						showInfoWindowReplacement(element, data.content);
					} else {
						if (currentlyOpenInfoWindow) {
							currentlyOpenInfoWindow.close();
						}

						infoWindow.open( map, marker );
						currentlyOpenInfoWindow = infoWindow;
					}
				} );

				google.maps.event.addListener( infoWindow, 'closeclick', function () {
					if ( activeIcon ) {
						marker.setIcon( icon );
					}

					currentlyOpenInfoWindow = null;
				} );

				google.maps.event.addListener( infoWindow, 'domready', function () {
					jQuery('.gm-style-iw').prev('div').remove();
				} );
			});
		}
	};

	if ( 'undefined' !== typeof garbeMaps && 0 < garbeMaps.length || 0 < $( '.locations-filter-places' ).length ) {
		$.getScript( 'https://maps.googleapis.com/maps/api/js?key=' + GARBE_GOOGLE_MAPS_API_KEY + '&language=' + encodeURIComponent($('html').attr('lang')) ).then( function () {
			$( document ).triggerHandler( 'googleMapsLoaded' );

			if ( 'undefined' !== typeof garbeMaps && 0 < garbeMaps.length ) {
				garbeMaps.forEach( function ( map ) {
					createMap.apply( null, map );
				} )
			}
		} );
	}

} )( jQuery );